/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Follow_UpInputs */

const cs_enum_follow_up = /** @type {(inputs: Enum_Follow_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-up`)
};

const en_enum_follow_up = /** @type {(inputs: Enum_Follow_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-up`)
};

/**
* | output |
* | --- |
* | "Follow-up" |
*
* @param {Enum_Follow_UpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_follow_up = /** @type {((inputs?: Enum_Follow_UpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Follow_UpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_follow_up(inputs)
	return cs_enum_follow_up(inputs)
});